export default {
  title: 'Aide & Support',

  // Common
  common: {
    of: 'sur',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    by: 'par',
    cancel: 'Annuler',
  },

  // Status labels
  status: {
    open: 'Ouvert',
    inProgress: 'En cours',
    waiting: 'En attente de réponse',
    resolved: 'Résolu',
    closed: 'Fermé'
  },

  // Priority labels
  priority: {
    low: 'Faible',
    medium: 'Moyenne',
    high: 'Élevée',
    urgent: 'Urgente'
  },

  // Filters
  filters: {
    all: 'Tous',
    status: 'Statut',
    priority: 'Priorité',
    search: 'Rechercher des tickets...'
  },

  // Quick actions
  quickActions: {
    title: 'Actions rapides',
    clearFilters: 'Effacer les filtres',
    export: 'Exporter les tickets'
  },

  // Stats
  stats: {
    open: 'Ouverts',
    inProgress: 'En cours',
    resolved: 'Résolus'
  },

  // Empty states
  empty: {
    noTickets: 'Aucun ticket',
    createFirst: 'Créez votre premier ticket pour obtenir de l\'aide',
    noResults: 'Aucun ticket trouvé',
    tryDifferentFilters: 'Essayez d\'ajuster vos filtres'
  },

  // Loading
  loading: {
    tickets: 'Chargement des tickets...',
    ticketDetails: 'Chargement des détails du ticket...',
    noTickets: 'Aucun ticket trouvé',
    description: 'Vous n\'avez aucun ticket ouvert pour le moment. Veuillez créer un nouveau ticket pour obtenir de l\'aide.',
  },

  // Time
  time: {
    justNow: 'à l\'instant',
    minutesAgo: 'il y a {count}m',
    hoursAgo: 'il y a {count}h',
    daysAgo: 'il y a {count}j'
  },

  // Validation
  validation: {
    required: 'Ce champ est requis'
  },

  // Toolbar
  toolbar: {
    title: 'Aide & Support',
  },

  // Buttons
  btn: {
    newTicket: 'Nouveau Ticket',
    createTicket: 'Créer le ticket',
  },

  // Tickets
  tickets: {
    title: 'Tickets de support',
    subtitle: 'Suivez et gérez vos demandes de support',
    myTickets: 'Mes tickets',
    description: 'Retrouvez ici la liste de vos demandes d\'assistance ou signalements.',
    showing: 'Affichage de {count} sur {total} tickets',

    list: {
      title: 'Liste des tickets',
      noTickets: 'Aucun ticket trouvé',
      createTicket: 'Créer un nouveau ticket',
      noClosedTickets: 'Aucun ticket fermé',
      descriptionNoClosedTickets: 'Vous n\'avez aucun ticket fermé pour le moment.',
      noOpenTickets: 'Aucun ticket ouvert',
      descriptionNoOpenTickets: 'Vous n\'avez aucun ticket ouvert pour le moment.',
      filters: {
        status: 'Statut',
        open: 'Ouvert',
        closed: 'Fermé',
        all: 'Tous',
      }
    },

    create: {
      title: 'Créer un nouveau ticket',
      subtitle: 'Décrivez votre problème ou demande et notre équipe vous aidera',
      priority: 'Priorité',
      subject: 'Sujet',
      subjectPlaceholder: 'Résumé concis du problème',
      description: 'Description',
      descriptionPlaceholder: 'Fournissez une description détaillée de votre problème ou demande...',
      createTicket: 'Créer le ticket',
      category: 'Catégorie',
      attachments: 'Pièces jointes',
      attachmentsPlaceholder: 'Cliquez pour sélectionner des fichiers ou glissez-les ici',
      submitSuccess: 'Ticket créé avec succès',
      submitError: 'Erreur lors de la création du ticket',
      categories: {
        technical: 'Problème technique',
        billing: 'Question sur la facturation',
        feature: 'Demande de fonctionnalité',
        general: 'Demande générale'
      },
      tips: {
        title: 'Conseils pour une résolution rapide',
        tip1: 'Soyez précis sur le problème',
        tip2: 'Incluez les messages d\'erreur',
        tip3: 'Joignez des captures d\'écran pertinentes',
        tip4: 'Mentionnez les étapes pour reproduire'
      },
      responseTime: {
        title: 'Temps de réponse attendu',
        low: '48-72 heures',
        medium: '24-48 heures',
        high: '6-12 heures',
        urgent: '1-2 heures'
      }
    },

    detail: {
      title: 'Détails du ticket',
      status: 'Statut',
      priority: 'Priorité',
      description: 'Description',
      messages: 'Conversation',
      newMessages: 'Nouveaux messages',
      addMessage: 'Ajouter un message',
      addReply: 'Ajouter une réponse',
      closeTicket: 'Fermer le ticket',
      reopenTicket: 'Rouvrir le ticket',
      send: 'Envoyer',
      noMessages: 'Aucun message pour le moment',
      typeMessage: 'Tapez votre message...',
      messageSent: 'Message envoyé avec succès',
      messageSendError: 'Erreur lors de l\'envoi du message',
      ticketClosed: 'Ticket fermé avec succès',
      ticketReopened: 'Ticket rouvert avec succès',
      ticketClosedMessage: 'Ce ticket est fermé. Rouvrez-le pour continuer la conversation.',
      assignedTo: 'Assigné à',
      category: 'Catégorie',
      created: 'Créé',
      lastUpdate: 'Dernière mise à jour',
      resolution: 'Résolution',
      details: 'Détails',
      requester: 'Demandeur',
      attachments: 'Pièces jointes',
      supportTeam: 'Équipe de support',
      export: 'Exporter',
      print: 'Imprimer',
      closeConfirmation: 'Êtes-vous sûr de vouloir fermer ce ticket ?',
      closeReason: 'Notes de résolution (optionnel)',
      confirmClose: 'Fermer le ticket',
      closeError: 'Erreur lors de la fermeture du ticket',
      reopenError: 'Erreur lors de la réouverture du ticket',
      loadError: 'Erreur lors du chargement des détails du ticket'
    }
  }
}
